<div 
  class="logo"
  [style.width]="logoWidth"
  [style.height]="logoHeight"
  [ngClass]="{ 'dark-logo': type === 'dark', 'light-logo': type === 'light' }">
</div>